import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { updateBuyData, updateSwapData } from "../../store/actions/UserAction";
import LogoutModal from "../Modals/LogoutModal";
import { useTranslation } from "react-multi-lang";
import AccountDetailsModal from "../Modals/AccountDetailsModal";
import { getErrorNotificationMessage } from "../helper/ToastNotification";
import KYCUpdateModal from "../KYC/KYCUpdateModal";

const SideBar = () => {
  
  const location = useLocation();
  const dispatch = useDispatch();
  const t = useTranslation("new_layout.sidebar");
  const buyData = useSelector((state) => state.user.buyData);
  const swapData = useSelector((state) => state.user.swapData);
  const profile = useSelector((state) => state.user.profile);
  const setBuyData = (data) => dispatch(updateBuyData(data));
  const setSwapData = (data) => dispatch(updateSwapData(data));
  const [logoutShow, setLogoutShow] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const kycApplicant = useSelector((state) => state.user.kycApplicant);
  const [kyc, setKyc] = useState(false);
  const [skipRender, setSkipRender] = useState(true);

  const handleLogout = () => {
    setLogoutShow(true);
    setBuyData({
      ...buyData,
      step: 1,
    });
    setSwapData({
      ...swapData,
      step: 1,
    });
  };

  const closeKycModal = () => {
    setKyc(false);
  };

  useEffect(() => {
    if (
      !skipRender &&
      !kycApplicant.loading &&
      Object.keys(kycApplicant.data).length > 0 &&
      location.pathname !== "/profile"
    ) {
      setKyc(kycApplicant.data);
    }
    setSkipRender(false);
  }, [kycApplicant]);

  return (
    <div className="sidebar-wrapped">
      <ul className="list-unstyled">
        <li
          className={`nav-item ${
            location.pathname === "/wallet-currency-list" ||
            location.pathname.split("/")[1] == "wallet"
              ? "active"
              : ""
          }`}
        >
          <Link to="/wallet-currency-list" className="nav-items">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              id="Layer_1"
              width="24"
              height="24"
              data-name="Layer 1"
              viewBox="0 0 24 24"
              fill="#878E96"
            >
              <path d="M21 6H5a3.01 3.01 0 0 1-2.235-.999A3 3 0 0 1 5 4h18a1 1 0 1 0 0-2H5a5 5 0 0 0-5 5v10a5 5 0 0 0 5 5h16a3 3 0 0 0 3-3V9a3 3 0 0 0-3-3m1 13c0 .551-.448 1-1 1H5c-1.654 0-3-1.346-3-3V6.998A5 5 0 0 0 5 8h16c.552 0 1 .449 1 1zm-2-5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"></path>
            </svg>
            <span>{t("wallet")}</span>
          </Link>
        </li>
        <li
          className={`nav-item ${
            ["/recipient-list", "/create-personal-recipient"].includes(
              location.pathname
            )
              ? "active"
              : ""
          }`}
        >
          <Link to="/recipient-list" className="nav-items">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              id="Layer_1"
              width="24"
              height="24"
              data-name="Layer 1"
              viewBox="0 0 24 24"
              fill="#878E96"
            >
              <path d="M0 22h24v2H0zM24 7.909V10h-3v8h2v2H1v-2h2v-8H0V7.909a3 3 0 0 1 1.563-2.634l9-4.909a3 3 0 0 1 2.874 0l9 4.909A3 3 0 0 1 24 7.909M5 18h3v-8H5zm5-8v8h4v-8zm9 0h-3v8h3zm3-2.091a1 1 0 0 0-.521-.878l-9-4.909a1 1 0 0 0-.958 0l-9 4.909A1 1 0 0 0 2 7.909V8h20z"></path>
            </svg>
            <span>{t("bank_accounts")}</span>
          </Link>
        </li>
        {(profile.data?.fr_status == "ACTIVE" && profile.data.user_configuration.within_pay_users) ? (
          <li
            className={`nav-item ${
              [
                "/internal-transafer-list",
                "/create-personal-recipient",
              ].includes(location.pathname)
                ? "active"
                : ""
            }`}
          >
            <Link to="/internal-transafer-list" className="nav-items">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                height="30"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g fill="#878E96" fillRule="evenodd" clipRule="evenodd">
                  <path d="M2 5.45A3.45 3.45 0 0 1 5.45 2h10.2a3.45 3.45 0 0 1 3.45 3.45v3.327a.75.75 0 0 1-1.5 0V5.45a1.95 1.95 0 0 0-1.95-1.95H5.45A1.95 1.95 0 0 0 3.5 5.45v10.2a1.95 1.95 0 0 0 1.95 1.95h5.793a.75.75 0 0 1 0 1.5H5.45A3.45 3.45 0 0 1 2 15.65zm3.6 2.1a1.05 1.05 0 1 1 2.1 0 1.05 1.05 0 0 1-2.1 0m3.6 0a.75.75 0 0 1 .75-.75h4.8a.75.75 0 0 1 0 1.5h-4.8a.75.75 0 0 1-.75-.75m-3.6 3.6a1.05 1.05 0 1 1 2.1 0 1.05 1.05 0 0 1-2.1 0m3.6 0a.75.75 0 0 1 .75-.75h3.3a.75.75 0 0 1 0 1.5h-3.3a.75.75 0 0 1-.75-.75m-3.6 3.6a1.05 1.05 0 1 1 2.1 0 1.05 1.05 0 0 1-2.1 0m3.6 0a.75.75 0 0 1 .75-.75h3.3a.75.75 0 0 1 0 1.5h-3.3a.75.75 0 0 1-.75-.75"></path>
                  <path d="M17.15 10.2a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5m-1.35 2.75a1.35 1.35 0 1 1 2.7 0 1.35 1.35 0 0 1-2.7 0M14.75 16.2a2.15 2.15 0 0 0-2.15 2.15c0 .847.341 1.698 1.1 2.331.756.63 1.894 1.019 3.45 1.019s2.694-.39 3.45-1.02a2.99 2.99 0 0 0 1.1-2.33 2.15 2.15 0 0 0-2.15-2.15zM14 18.35a.75.75 0 0 1 .75-.75h4.8a.75.75 0 0 1 .75.75c0 .454-.176.902-.598 1.254-.434.362-1.22.696-2.552.696s-2.12-.333-2.553-.694A1.59 1.59 0 0 1 14 18.35"></path>
                </g>
              </svg>
              <span>Within Pay User</span>
            </Link>
          </li>
        ) : null}
        <li
          className={`nav-item ${
            location.pathname === "/transactions" ? "active" : ""
          }`}
        >
          <Link to="/transactions" className="nav-items">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              id="Outline"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="#878E96"
            >
              <path d="m23.421 16.583-3.291-3.291a1 1 0 1 0-1.413 1.414L21.007 17a9.33 9.33 0 0 1-6.686-2.8.98.98 0 0 0-1.408.08l-.013.02a1 1 0 0 0 .075 1.382A11.18 11.18 0 0 0 21.01 19l-2.293 2.293A1 1 0 1 0 20.13 22.7l3.291-3.291a2 2 0 0 0 0-2.826"></path>
              <path d="m21.007 7-2.29 2.29a1 1 0 0 0-.054.082.992.992 0 0 0 1.467 1.332L21.836 9l1.586-1.585a2 2 0 0 0 .457-2.1 2 2 0 0 0-.458-.728L20.13 1.3a1 1 0 1 0-1.413 1.413l2.293 2.292c-4.933.012-7.637 2.674-10.089 5.474C8.669 7.937 6 5.4 1.487 5.046L1.006 5a1 1 0 0 0-1 1 1.02 1.02 0 0 0 1 1c.072 0 .287.033.287.033C5.189 7.328 7.425 9.522 9.6 12c-2.162 2.466-4.383 4.7-8.247 4.96l-.4.021a.994.994 0 1 0 .124 1.985c.156-.007.41-.013.535-.023 5.02-.387 7.743-3.6 10.171-6.409C14.235 9.7 16.551 7.018 21.007 7"></path>
            </svg>
            <span>{t("transactions")}</span>
          </Link>
        </li>
        <li
          className={`nav-item ${
            location.pathname === "/profile" ? "active" : ""
          }`}
        >
          <Link to="/profile" className="nav-items">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              id="Outline"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="#878E96"
            >
              <path d="M12 12a6 6 0 1 0-6-6 6.006 6.006 0 0 0 6 6m0-10a4 4 0 1 1-4 4 4 4 0 0 1 4-4M12 14a9.01 9.01 0 0 0-9 9 1 1 0 0 0 2 0 7 7 0 0 1 14 0 1 1 0 0 0 2 0 9.01 9.01 0 0 0-9-9"></path>
            </svg>
            <span>{t("profile")}</span>
          </Link>
        </li>
        {(profile.data?.user_service_type == "fr" &&
          profile.data?.fr_status == "ACTIVE" && profile.data.user_configuration.iban_preview) ? (
            <li className={`nav-item`}>
              <Link
                className="nav-items"
                to="/account-details"
                // onClick={() => {
                //     ((profile.data?.user_type == 1 && profile.data?.onboarding_completed == 1) || (profile.data?.user_type == 2 && profile.data?.onboarding == 2)) ?
                //         setModalShow(true) : getErrorNotificationMessage("Onboarding is not completed")
                // }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="23"
                  height="23"
                  fill="none"
                  viewBox="0 0 23 23"
                >
                  <path
                    fill="#878E96"
                    d="M11.5 6.597a.958.958 0 1 0 0-1.917.958.958 0 0 0 0 1.917"
                  ></path>
                  <path
                    fill="#878E96"
                    fillRule="evenodd"
                    d="M21.801 7.593V6.325c0-.686-.417-1.302-1.054-1.557l-8.625-3.45c-.4-.16-.846-.16-1.246 0l-8.625 3.45a1.68 1.68 0 0 0-1.054 1.557v1.268c0 .926.752 1.677 1.677 1.677h17.25c.926 0 1.677-.751 1.677-1.677m-1.437-1.268v1.268a.24.24 0 0 1-.24.24H2.874a.24.24 0 0 1-.24-.24V6.325a.24.24 0 0 1 .151-.222l8.625-3.45a.24.24 0 0 1 .178 0l8.626 3.45a.24.24 0 0 1 .15.222M2.869 20.29l.498-1.742a.24.24 0 0 1 .23-.174h7.423a.719.719 0 0 0 0-1.437H3.597c-.749 0-1.407.496-1.612 1.216l-.586 2.049a1.197 1.197 0 0 0 1.152 1.526h8.47a.719.719 0 0 0 0-1.437z"
                    clipRule="evenodd"
                  ></path>
                  <path
                    fill="#878E96"
                    fillRule="evenodd"
                    d="M19.885 9.583V8.551a.719.719 0 0 0-1.438 0v1.032a.719.719 0 0 0 1.438 0M15.572 9.583V8.551a.719.719 0 0 0-1.437 0v1.032a.719.719 0 0 0 1.437 0M8.864 17.655V8.551a.719.719 0 0 0-1.438 0v9.104a.719.719 0 0 0 1.438 0M4.551 17.655V8.551a.719.719 0 0 0-1.437 0v9.104a.719.719 0 0 0 1.437 0M17.288 14.998a4.517 4.517 0 0 0-4.515 4.515c0 .662.41 1.245 1.178 1.643.81.419 2.072.646 3.337.646s2.526-.227 3.336-.646c.768-.397 1.177-.981 1.177-1.643a4.517 4.517 0 0 0-4.513-4.515m0 1.437a3.08 3.08 0 0 1 3.076 3.078c0 .061-.042.106-.09.153a1.3 1.3 0 0 1-.31.214c-.648.335-1.664.485-2.676.485s-2.028-.15-2.676-.485a1.3 1.3 0 0 1-.311-.214c-.047-.047-.09-.092-.09-.153a3.08 3.08 0 0 1 3.077-3.078"
                    clipRule="evenodd"
                  ></path>
                  <path
                    fill="#878E96"
                    fillRule="evenodd"
                    d="M17.288 10.781a2.83 2.83 0 0 0-2.828 2.827 2.829 2.829 0 0 0 5.655 0 2.83 2.83 0 0 0-2.827-2.827m0 1.438a1.39 1.39 0 1 1-.002 2.78 1.39 1.39 0 0 1 .002-2.78"
                    clipRule="evenodd"
                  ></path>
                </svg>
                <span>Account Details</span>
              </Link>
            </li>
          ) : null}
        
        <li
          className={`nav-item ${
            location.pathname === "/whitelist-address" ? "active" : ""
          }`}
        >
          <Link to="/whitelist-address" className="nav-items">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="none"
              viewBox="0 0 24 24"
            >
              <g fill="#878E96">
                <path d="M19 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0"></path>
                <g fillRule="evenodd" clipRule="evenodd">
                  <path d="M3 3 2 4v7h2V5h13a3 3 0 0 1 3 3h-2a4 4 0 0 0 0 8h2a3 3 0 0 1-3 3h-3v2h3a5 5 0 0 0 5-5V8a5 5 0 0 0-5-5zm17 7h-2a2 2 0 1 0 0 4h2z"></path>
                  <path d="M9.935 13.327a4 4 0 1 0-.435 6.637l.75 1.3a5.5 5.5 0 1 1 2.239-2.448l-.202.434H8.75v-.3a2.75 2.75 0 1 1 0-4.9V14h1.5v3.75h1.05a4 4 0 0 0-1.365-4.423M6.25 16.5a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0"></path>
                </g>
              </g>
            </svg>
            <span>{t("whitelist_address")}</span>
          </Link>
        </li>
        {/* <li
          className={`nav-item ${
            location.pathname === "/payment-gateway-services" ? "active" : ""
          }`}
        >
          <Link to="/payment-gateway-services" className="nav-items">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              id="Layer_1"
              width="24"
              height="24"
              data-name="Layer 1"
              viewBox="0 0 24 24"
              fill="#878E96"
            >
              <path d="M0 22h24v2H0zM24 7.909V10h-3v8h2v2H1v-2h2v-8H0V7.909a3 3 0 0 1 1.563-2.634l9-4.909a3 3 0 0 1 2.874 0l9 4.909A3 3 0 0 1 24 7.909M5 18h3v-8H5zm5-8v8h4v-8zm9 0h-3v8h3zm3-2.091a1 1 0 0 0-.521-.878l-9-4.909a1 1 0 0 0-.958 0l-9 4.909A1 1 0 0 0 2 7.909V8h20z"></path>
            </svg>
            <span>{t("widget_sdk")}</span>
          </Link>
        </li> */}
        <li className={`nav-item`}>
          <Link to="#" onClick={handleLogout} className="nav-items">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="#878E96"
            >
              <g id="_01_align_center" data-name="01 align center">
                <path d="M2 21V3a1 1 0 0 1 1-1h5V0H3a3 3 0 0 0-3 3v18a3 3 0 0 0 3 3h5v-2H3a1 1 0 0 1-1-1"></path>
                <path d="m23.123 9.879-4.586-4.586-1.414 1.414 4.264 4.264L5 11v2l16.443-.029-4.322 4.322 1.414 1.414 4.586-4.586a3 3 0 0 0 .002-4.242"></path>
              </g>
            </svg>
            <span>{t("logout")}</span>
          </Link>
        </li>
      </ul>
      {logoutShow ? (
        <LogoutModal show={logoutShow} onHide={() => setLogoutShow(false)} />
      ) : null}
      {modalShow ? (
        <AccountDetailsModal
          show={modalShow}
          onHide={() => setModalShow(false)}
        />
      ) : null}
      {kyc && <KYCUpdateModal kyc={kyc} closeKyc={closeKycModal} />}
    </div>
  );
};

export default SideBar;
